export const menuItems = [
  {
    group: 'reporting',
    label: 'sidebar.Usage',
    to: '/usage',
    icon: 'data_usage',
  },
  {
    group: 'management',
    label: 'sidebar.Environments',
    to: '/environments',
    icon: 'domain',
  },
  {
    group: 'management',
    label: 'sidebar.Accounts',
    to: '/accounts',
    icon: 'manage_accounts',
  },
];
